import { r as registerInstance, h, g as getElement, H as Host } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import { aj as pesIconSizes, ak as pesIconMirrorDirection, a1 as ICONS_BY_TYPE } from './currency-7be6806c.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import './index-e29b327a.js';
import { i as isAnalyticsEnabled } from './helpers-e12aa36b.js';
import { s as send, x as productSelectorVirtualPageEvent } from './analytics-b6a65ffa.js';
import './_commonjsHelpers-11ca3be1.js';
import './_nodeUtil-f95b2b52.js';
import './lodash-bd96d09c.js';
import './analytics-205f1857.js';
import './_Stack-68736bd1.js';
import './number-57a50dcb.js';

const actionBlockCss = ".action-block{box-sizing:border-box;flex:1;min-height:130px;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;padding:0 28px}.action-block *,.action-block *::before,.action-block *::after{box-sizing:inherit}.action-block--small .action-block__heading,.action-block--small .action-block__text{font-size:13px;line-height:15px}.action-block__heading{font-size:16px;line-height:25px;margin:0 0 8px;color:#333333;text-align:center;max-width:100%}.action-block__text-content{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;font-size:15px;line-height:20px;font-weight:normal;text-align:center}.action-block__text-content:hover{text-decoration:underline}.action-block__text-content:hover{text-decoration:none}.action-block__text{display:inline;text-transform:capitalize}.action-block:hover .action-block__text{text-decoration:underline}.action-block__text-arrow-icon{display:inline-flex;align-items:center;height:20px;width:20px;vertical-align:middle;position:relative;bottom:1px}:host(:not([dir=\"rtl\"])) .action-block__text-arrow-icon{left:2px}:host([dir=\"rtl\"]) .action-block__text-arrow-icon{right:2px;transform:scaleX(-1)}";

const ActionBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.heading = undefined;
    this.url = undefined;
    this.text = undefined;
    this.icon = 'segment_retail';
    this.size = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("pes-banner", { url: this.url, icon: this.icon }, h("div", { class: classnames('action-block', { 'action-block--small': this.size === 'small' }) }, h("h3", { class: "action-block__heading", innerHTML: this.heading }), h("span", { class: "action-block__text-content" }, h("span", { class: "action-block__text", innerHTML: this.text }), h("pes-icon", { class: "action-block__text-arrow-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")))));
  }
  get el() { return getElement(this); }
};
ActionBlock.style = actionBlockCss;

const ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.renderActionBlock = () => (h("pes-action-block", { heading: this.actionBlock.label, text: this.actionBlock.linkText, icon: ICONS_BY_TYPE[this.actionBlock.type], onClick: this.handleClick }));
    this.handleClick = () => {
      this.opened = true;
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent);
      }
    };
    this.handleLoaderClick = () => {
      this.opened = false;
    };
    this.actionBlock = undefined;
    this.selectorConfig = undefined;
    this.opened = false;
    this.selector = undefined;
  }
  openProductSelector() {
    if (!this.opened || !this.selectorConfig || !this.selector) {
      return;
    }
    if (this.selectorConfig.type === 'sc') {
      const host = document.createElement('pdp-sc-selector-modal');
      const frame = document.createElement('div');
      frame.id = 'widgetFrame';
      host.headerLabel = this.selectorConfig.scLabel || 'Select your product';
      host.appendChild(frame);
      host.open = true;
      host.addEventListener('didClose', () => {
        document.body.removeChild(host);
        this.opened = false;
      });
      document.body.appendChild(host);
    }
    this.selector.open(this.getSelectorConfig());
  }
  getSelectorConfig() {
    var _a;
    return Object.assign(Object.assign({}, this.selectorConfig), { scOptions: !isEmpty_1((_a = this.actionBlock.selectorConfig) === null || _a === void 0 ? void 0 : _a.scOptions)
        ? this.actionBlock.selectorConfig.scOptions
        : {} });
  }
  render() {
    return (h(Host, null, h("se-loading", { loading: this.opened && !this.selectorConfig, onClick: this.handleLoaderClick, fullPage: true, overlay: true }), this.selectorConfig ? (h("pes-product-selector", { config: this.getSelectorConfig(), renderFunction: (selector) => {
        this.selector = selector;
        return this.renderActionBlock();
      } })) : (this.renderActionBlock())));
  }
  static get watchers() { return {
    "opened": ["openProductSelector"],
    "selectorConfig": ["openProductSelector"],
    "selector": ["openProductSelector"]
  }; }
};

export { ActionBlock as pes_action_block, ProductSelector as pes_action_block_product_selector };
